import { action } from 'satcheljs';
export const onClientReadingPanePositionChange: () => {} = action(
    'onClientReadingPanePositionChange'
);
